import Tool from 'editor/components/Tool';

export enum MapboxTools {
  Pointer = 'Pointer',
  PostRFI = 'PostRFI',
  PlacePunch = 'PlacePunch',
}

export default class MapboxTool extends Tool<MapboxTools> {}
